import { Modal } from 'components/common/Modal/Modal';
import { useState } from 'react';
import i18n from 'i18n';
import { DefaultRtbCampaignManager } from 'core/rtbCampaign/RtbCampaignManager';
import { useCallAPI } from 'hooks/useCallAPI';
import { LoadingIndicator } from 'components/common/LoadingIndicator';

export type BidWeightModalProps = {
  campaign: {
    id: number;
    magnificationRatio: number;
  };
  onFinish: () => void;
  onClose: () => void;
};

const campaignManager = new DefaultRtbCampaignManager();

const MIN_BID_WEIGHT = 0.01;

export const BidWeightModal: React.FC<BidWeightModalProps> = ({
  campaign,
  onFinish,
  onClose
}) => {
  const { loading, callAPIs } = useCallAPI();
  const [magnificationRatio, setMagnificationRatio] = useState<
    number | undefined
  >(campaign.magnificationRatio);

  const onConfirm = () => {
    if (!magnificationRatio) {
      return;
    }
    callAPIs(
      [
        () =>
          campaignManager.updateCampaignBidWeight(
            campaign.id,
            magnificationRatio
          )
      ],
      onFinish
    );
  };

  const onInputValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      return setMagnificationRatio(undefined);
    }
    setMagnificationRatio(+e.target.value);
  };

  return (
    <>
      {loading && <LoadingIndicator />}
      <Modal
        title={i18n.t('campaignList.labels.manageBidWeightModalTitle')}
        primaryButton={{
          title: i18n.t('common.buttons.confirm'),
          callback: onConfirm,
          disabled: !magnificationRatio || magnificationRatio < MIN_BID_WEIGHT
        }}
        secondaryButton={{
          title: i18n.t('common.buttons.cancel'),
          callback: onClose
        }}
        dismiss={onClose}
      >
        <input
          value={magnificationRatio}
          onChange={onInputValueChange}
          type='number'
          min={MIN_BID_WEIGHT}
        />
      </Modal>
    </>
  );
};
